import { h } from 'preact';
import * as BaseComp from 'components/shared/youtube/youtube.js';
import s from 'components/shared/youtube/youtube.sss';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import { accessNested } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { oneTrust } from 'utils/gdpr';

class Youtube extends BaseComp.default {

	render(props, state) {
		if (!accessNested(props, 'appData.apis.tracking.oneTrust') || state.oneTrustAllowed) {
			return super.render(props, state);
		}
		return (
			<div class={s.placeholder}>
				<div>{getCopy('$TRACKING_YOUTUBE_UNAVAILABLE')}</div>
			</div>
		);
	}

}

export default oneTrust.connectToOneTrust(oneTrust.TARGETING, Youtube);
